import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { getGridPosition } from "./utility";

const Root = styled.div((props) => {
  const { $rows, $columns, $alignment, $gap, $grow } = props;
  return {
    columnGap: $gap?.x,
    rowGap: $gap?.y,
    display: "grid",

    justifyContent: getGridPosition($alignment?.container?.horizontal),
    alignContent: getGridPosition($alignment?.container?.vertical),
    justifyItems: getGridPosition($alignment?.item?.horizontal),
    alignItems: getGridPosition($alignment?.item?.vertical),
    "@media(min-width: 1300px)": {
      gridTemplateColumns:
        $columns !== undefined
          ? `repeat(${$columns}, ${$grow ? "1fr" : "auto"})`
          : undefined,
      gridTemplateRows:
        $rows !== undefined
          ? `repeat(${$rows}, ${$grow ? "1fr" : "auto"})`
          : undefined,
    },
  };
});

function Grid(props) {
  const { rows, columns, alignment, children, gap, grow = false } = props;

  return (
    <Root
      data-component-name="grid"
      $gap={gap}
      $rows={rows}
      $columns={columns}
      $alignment={alignment}
      $grow={grow}
    >
      {children}
    </Root>
  );
}

Grid.propTypes = {
  children: PropTypes.node,
  rows: PropTypes.number,
  columns: PropTypes.number,
  gap: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  alignment: PropTypes.shape({
    container: PropTypes.shape({
      vertical: PropTypes.oneOf(["top", "middle", "between", "bottom"]),
      horizontal: PropTypes.oneOf(["left", "middle", "between", "right"]),
    }),
    item: PropTypes.shape({
      vertical: PropTypes.oneOf(["top", "middle", "bottom"]),
      horizontal: PropTypes.oneOf(["left", "middle", "right"]),
    }),
  }),
};

export default Grid;
